import React from 'react';
import PackagesPage from 'components/PackagesPage';

const EcommercePage = () => {
  return (
    <div>
      <PackagesPage
        category={'ecommerce'}
        messageID={'pages.products.ecommercePage'}
        descriptionID={'pages.products.ecommercePage.description'}
      />
    </div>
  );
};

export default EcommercePage;
